<button
  type="button"
  mdbBtn
  mdbWavesEffect
  tabindex="0"
  [id]="id"
  [ngbTooltip]="tooltip"
  [color]="color"
  [size]="size"
  [disabled]="disabled || (spinner && !spinner.isStopped)"
  [classList]="_class"
  [class.disabled]="disabled || (spinner && !spinner.isStopped)"
  [outline]="outline"
  [block]="block"
  (click)="handleClick()"
  data-testid="bary-button"
>
  <span *ngIf="spinner">
    <span *ngIf="spinner && !spinner.isStopped" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span *ngIf="spinner && !spinner.isStopped" class="ml-1"> {{ _spinnerLabel }}</span>
    <mdb-icon *ngIf="icon && spinner.isStopped" fas [icon]="icon" class="mr-1"></mdb-icon>
    <span *ngIf="spinner.isStopped">{{ label }}</span>
  </span>
  <span *ngIf="!spinner">
    <mdb-icon *ngIf="icon" fas [icon]="icon" class="mr-1"></mdb-icon>
    <span>{{ label }}</span>
  </span>
</button>
